import { Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

type ProcessingStartedNotificationProps = {
    isSummaryOnly: boolean;
};

export const ProcessingStartedNotification = ({
    isSummaryOnly,
}: ProcessingStartedNotificationProps) => {
    const { formatMessage } = useIntl();

    const messageId = isSummaryOnly
        ? 'experiment.better_business.dossier.discussion.phone_call.notification.summary_processing_started'
        : 'experiment.better_business.dossier.discussion.phone_call.notification.processing_started';

    return (
        <Typography
            sx={{ color: 'inherit', fontWeight: 700, fontFamily: 'inherit' }}
            variant="body2"
        >
            {formatMessage({ id: messageId })}
        </Typography>
    );
};
